import { useContext, useState } from "react";
import { SettingOption } from "../../../components/SettingOption/setting-option";
import { UpdateSetting } from "../../../utils/httpUtils";
import { UserContext } from "../../../context/UserContext";
import { NotificationsContext } from "../../../context/NotificationsContext";
import { GetLocalSetting, SetLocalSetting } from "../../../utils/genericUtils";
import ThemeContext from "../../../context/ThemeContext";

const defaultProps = {
  theme: "",
};

export default function InterfaceSettings(props = defaultProps) {
  //context
  const { user, loginUser } = useContext(UserContext);
  const { pushNotification } = useContext(NotificationsContext);
  const { setTheme } = useContext(ThemeContext);

  //state
  const [enableDarkMode, setEnableDarkMode] = useState(GetLocalSetting("theme"));
  const [show_hidden_objects, setShowHiddenObjects] = useState(GetLocalSetting("show_hidden_objects"));

  //
  function EnableDarkMode(enabled) {
    setEnableDarkMode(enabled);

    setTheme(enabled ? "dark" : "light");

    SetLocalSetting("theme", enabled ? "dark" : "light");

    UpdateSetting("theme", enabled ? "dark" : "light", user).then((response) => {
      if (response.success) {
        let message = enabled ? "Dark Mode enabled" : "Dark Mode disabled";
        pushNotification("Setting Updated", message);
      } else {
        setEnableDarkMode(!enabled);
        pushNotification("Setting Failed To Update", (response.error && response.error.message) ?? "Unknown error occured");
      }
    });
  }

  function ToggleHiddenObjects(enabled) {
    setShowHiddenObjects(enabled);
    let message = enabled ? "Hidden objects are now visible" : "Hidden objects are no longer visible";
    pushNotification("Setting Updated", message);
    SetLocalSetting("show_hidden_objects", enabled);
  }

  return (
    <div>
      <SettingOption
        id={"interface-option-1"}
        controlType={"toggle"}
        defaultValue={enableDarkMode === "dark"}
        onChange={(value) => EnableDarkMode(value)}
        description="Dark Mode"
      />
      <SettingOption
        id={"storage-option-1"}
        controlType={"toggle"}
        defaultValue={show_hidden_objects}
        onChange={(value) => ToggleHiddenObjects(value)}
        description="Show Hidden Objects"
      />
    </div>
  );
}
